import cn from 'classnames';
import PropTypes from 'prop-types';
import { ResponsivePie } from '@nivo/pie';

import { EmptyChart } from '../pages/Analytics/EmptyChart';
import { AnalyticsItemBox } from '../pages/Analytics/AnalyticsItemBox';
import { PieCenteredMetric } from './legends/PieCenteredMetric';
import { SalesByChannelsTooltip } from './tooltips/SalesByChannelsTooltip';

import { baseLegend, graphColors, graphTheme } from './consts';

import styles from './graph.module.scss';

export function SalesByChannelsPie({ title, metric, data, currency, isGmvMetric, uiDataKey, currentOrderType }) {
  const uiData = data[uiDataKey];

  return (
    <AnalyticsItemBox title={title} metric={metric}>
      <div className={cn(styles.graphWrapper, styles.pieGraph, data.length === 0 ? styles.noData : '')}>
        {uiData.length > 0 ? (
          <ResponsivePie
            data={uiData}
            margin={{ top: 8, right: 132, bottom: 8, left: 0 }}
            innerRadius={0.5}
            padAngle={2}
            cornerRadius={3}
            legends={[baseLegend]}
            arcLabel={(pieSlice) => `${pieSlice.value}%`}
            sortByValue
            enableArcLinkLabels={false}
            arcLabelsSkipAngle={17}
            theme={graphTheme}
            colors={graphColors}
            isInteractive
            animate
            layers={['arcs', 'arcLabels', 'legends', PieCenteredMetric({ isGmvMetric, currency, currentOrderType })]}
            tooltip={SalesByChannelsTooltip({
              allData: data,
              isGmvMetric,
              currency,
              dataKey: uiDataKey,
            })}
            activeOuterRadiusOffset={8}
          />
        ) : (
          <EmptyChart />
        )}
      </div>
    </AnalyticsItemBox>
  );
}

SalesByChannelsPie.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    gmv: PropTypes.arrayOf(PropTypes.object).isRequired,
    units: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  metric: PropTypes.string,
  isGmvMetric: PropTypes.bool.isRequired,
  currency: PropTypes.string.isRequired,
};
